import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

/** @visibleName Child Observer */
export default class ChildObserver extends PureComponent {
  static propTypes = {
    onMutation: PropTypes.func.isRequired,
    options: PropTypes.object,
    children: PropTypes.node,
  };

  static defaultProps = {
    options: {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style'],
    },
  };

  constructor(props) {
    super(props);

    this.onMutation = this.onMutation.bind(this);
    this.toRef = this.toRef.bind(this);
  }

  componentDidMount() {
    this.observer = new MutationObserver(this.onMutation);
    this.observer.observe(this.el, this.props.options);
  }

  /* istanbul ignore next */
  onMutation(mutations) {
    this.props.onMutation();
  }

  toRef(el) {
    this.el = el;
  }

  render() {
    return <div ref={this.toRef}>{this.props.children}</div>;
  }
}
